/**
 * Centre Page hero interactions (trust badge popovers).
 */
(function () {
	function onReady(fn) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', fn);
		} else {
			fn();
		}
	}

	/**
	 * Position a tooltip beside its trigger without allowing viewport overflow.
	 *
	 * @param {HTMLElement} trigger Tooltip trigger.
	 * @param {HTMLElement} tooltip Tooltip element.
	 */
	function positionNqsTooltip(trigger, tooltip) {
		var gutter = 12;
		var gap = 8;
		var triggerRect = trigger.getBoundingClientRect();
		var tooltipRect = tooltip.getBoundingClientRect();
		var spaceAbove = triggerRect.top - gutter - gap;
		var spaceBelow = window.innerHeight - triggerRect.bottom - gutter - gap;
		var placeBelow = tooltipRect.height > spaceAbove && spaceBelow > spaceAbove;
		var idealLeft = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);
		var maxLeft = Math.max(gutter, window.innerWidth - tooltipRect.width - gutter);
		var left = Math.min(Math.max(idealLeft, gutter), maxLeft);
		var idealTop = placeBelow
			? triggerRect.bottom + gap
			: triggerRect.top - tooltipRect.height - gap;
		var maxTop = Math.max(gutter, window.innerHeight - tooltipRect.height - gutter);
		var top = Math.min(Math.max(idealTop, gutter), maxTop);
		var triggerCenter = triggerRect.left + (triggerRect.width / 2);
		var arrowLeft = Math.min(
			Math.max(triggerCenter - left, 12),
			Math.max(12, tooltipRect.width - 12)
		);

		tooltip.style.left = left + 'px';
		tooltip.style.top = top + 'px';
		tooltip.style.setProperty('--nqs-tooltip-arrow-left', arrowLeft + 'px');
		tooltip.setAttribute('data-placement', placeBelow ? 'below' : 'above');
	}

	function initNqsTooltips() {
		var triggers = document.querySelectorAll('.nqs-tooltip[data-tooltip]');
		var activeTrigger = null;
		var activeTooltip = null;

		if (!triggers.length) {
			return;
		}

		function hideTooltip(trigger, tooltip) {
			tooltip.setAttribute('hidden', '');

			if (activeTrigger === trigger) {
				activeTrigger = null;
				activeTooltip = null;
			}
		}

		function showTooltip(trigger, tooltip) {
			if (activeTooltip && activeTooltip !== tooltip) {
				activeTooltip.setAttribute('hidden', '');
			}

			tooltip.removeAttribute('hidden');
			positionNqsTooltip(trigger, tooltip);
			activeTrigger = trigger;
			activeTooltip = tooltip;
		}

		triggers.forEach(function (trigger, index) {
			var content = trigger.getAttribute('data-tooltip');
			var tooltip = document.createElement('div');
			var tooltipId = 'nqs-tooltip-' + (index + 1);

			if (!content) {
				return;
			}

			tooltip.className = 'nqs-tooltip__popup';
			tooltip.id = tooltipId;
			tooltip.setAttribute('role', 'tooltip');
			tooltip.setAttribute('hidden', '');
			tooltip.textContent = content;
			document.body.appendChild(tooltip);

			trigger.setAttribute('aria-describedby', tooltipId);
			if (!trigger.hasAttribute('tabindex')) {
				trigger.setAttribute('tabindex', '0');
			}

			trigger.addEventListener('mouseenter', function () {
				showTooltip(trigger, tooltip);
			});
			trigger.addEventListener('mouseleave', function () {
				hideTooltip(trigger, tooltip);
			});
			trigger.addEventListener('focus', function () {
				showTooltip(trigger, tooltip);
			});
			trigger.addEventListener('blur', function () {
				hideTooltip(trigger, tooltip);
			});
		});

		window.addEventListener('resize', function () {
			if (activeTrigger && activeTooltip) {
				positionNqsTooltip(activeTrigger, activeTooltip);
			}
		});

		window.addEventListener('scroll', function () {
			if (activeTrigger && activeTooltip) {
				positionNqsTooltip(activeTrigger, activeTooltip);
			}
		}, true);

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && activeTrigger && activeTooltip) {
				var trigger = activeTrigger;

				hideTooltip(trigger, activeTooltip);
				trigger.blur();
			}
		});
	}

	function initTrustBadgePopovers() {
		var triggers = document.querySelectorAll('[data-trust-popover-trigger]');

		if (!triggers.length) {
			return;
		}

		triggers.forEach(function (trigger) {
			var panelId = trigger.getAttribute('aria-controls');
			var panel = panelId ? document.getElementById(panelId) : null;

			if (!panel) {
				return;
			}

			var closeBtn = panel.querySelector('[data-trust-popover-close]');

			function setOpen(open) {
				panel.classList.toggle('visible', open);
				panel.setAttribute('aria-hidden', open ? 'false' : 'true');
				trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
			}

			trigger.addEventListener('click', function (event) {
				event.preventDefault();
				event.stopPropagation();
				setOpen(!panel.classList.contains('visible'));
			});

			if (closeBtn) {
				closeBtn.addEventListener('click', function (event) {
					event.preventDefault();
					event.stopPropagation();
					setOpen(false);
				});
			}
		});

		document.addEventListener('click', function (event) {
			triggers.forEach(function (trigger) {
				var panelId = trigger.getAttribute('aria-controls');
				var panel = panelId ? document.getElementById(panelId) : null;

				if (!panel || !panel.classList.contains('visible')) {
					return;
				}

				if (panel.contains(event.target) || trigger.contains(event.target)) {
					return;
				}

				panel.classList.remove('visible');
				panel.setAttribute('aria-hidden', 'true');
				trigger.setAttribute('aria-expanded', 'false');
			});
		});

		document.addEventListener('keydown', function (event) {
			if (event.key !== 'Escape') {
				return;
			}

			triggers.forEach(function (trigger) {
				var panelId = trigger.getAttribute('aria-controls');
				var panel = panelId ? document.getElementById(panelId) : null;

				if (!panel || !panel.classList.contains('visible')) {
					return;
				}

				panel.classList.remove('visible');
				panel.setAttribute('aria-hidden', 'true');
				trigger.setAttribute('aria-expanded', 'false');
			});
		});

	}

	onReady(function () {
		if (!document.body.classList.contains('page-template-centre-page')) {
			return;
		}

		initNqsTooltips();
		initTrustBadgePopovers();
	});
})();
